import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as innovationIdea from '../innovation-idea'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: innovationIdea.RESOURCE.payload.dimension.partialId,
      partialId: innovationIdea.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Indicates whether executive committee approval was needed for this idea',
    isOptional: true,
    name: 'Executive Committee Approval',
    partialId: PartialId.Standard.create('executive_committee_approval'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
